import React from "react";
import {Tab, TabGroup, Text} from "@nike/eds";
import {PODCorrectionsOverview} from "../components/pod/PODCorrectionsOverview";
import {PODCertificateReport} from "../components/pod/PODCertificateReport";
import {PODService} from "../services/PODService";
import {GraphQlService} from "../services/GraphQlService";
import {oktaAuth} from "../config/OktaConfig";
import {Page} from "@nike/epic-react-ui";
import {useParams} from "react-router-dom";

interface PODContainerProps {
    history?: any;
    currentUser?: any;
    currentTerritories?: any;
}

export function PODContainer(props: PODContainerProps) {
    const {REACT_APP_POD_SERVICE_ENDPOINT: podServiceEndpoint} = process.env;
    const {tab} = useParams<{ tab?: string }>();
    const [activeTabId, setActiveTabId] = React.useState(tab ?? "corrections");
    const podGraphQlService: GraphQlService = React.useMemo(
        () => new GraphQlService(oktaAuth, podServiceEndpoint ?? ""),
        [oktaAuth, podServiceEndpoint] // eslint-disable-line react-hooks/exhaustive-deps
    );

    function changeTab(newTabId: string) {
        window.history.replaceState(null, "", `/pod/${newTabId}`);
        setActiveTabId(newTabId);
    }

    const podService: PODService = React.useMemo(
        () => new PODService(podGraphQlService),
        [podGraphQlService]
    );

    return (
        <Page documentTitle="POD - Customs Compliance Hub" width="full" className="eds-flex eds-flex--direction-column eds-gap--32 eds-spacing--p-24">
            <Text font="title-2">Preferential Origin Document</Text>
            <TabGroup
                name="pod-tab-group"
                activeId={activeTabId}
                onChange={e => changeTab(e.target.id)}
            >
                <Tab id="corrections" className="eds-type--title-5">Corrections</Tab>
                <Tab id="report" className="eds-type--title-5">Physical Cert Check Report</Tab>
            </TabGroup>
            <PODCorrectionsOverview activeTabId={activeTabId} podService={podService}/>
            <PODCertificateReport activeTabId={activeTabId} podService={podService}/>
        </Page>
    );
}